export default [
  {
    path: 'GuestRecordTabs',
    component: () => import('@/views/Guest/GuestRecordTabs.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'PlusGuestReservation', guestId: 'List' }
      }, {
        path: '/PlusGuestReservation/:guestId',
        name: 'PlusGuestReservation',
        component: () => import('@/views/Guest/page/PlusGuestReservation.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      }, {
        path: '/GuestRecord',
        name: 'GuestRecord',
        component: () => import('@/views/Guest/page/GuestRecord.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      }
    ]
  }
]
